import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import store from '@/store'
import { AloDbFleet, isAloDbFleetCoverage, isAloDbFleetFormation } from '@/models/alodb/AloDbFleet'
import MissionDetailNextSurfacingDo from '@/components/mission/MissionDetailNextSurfacingDo.vue'
import GliderCmdInput from '@/components/shared/GliderCmdInput.vue'
import mission from '@/api/mission'

type BroadcastKind = 'next' | 'all' | 'ncd'


export default /*#__PURE__*/_defineComponent({
  __name: 'FleetDetailNextSurfacingDo',
  props: {
    fleet: null,
    isleft: { type: Boolean },
    uiid: null,
    isVisible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  fleet: AloDbFleet
  isleft: boolean
  uiid: string
  isVisible: boolean
};



const nextSurfacingCmd = ref('')
const allSurfacingCmd = ref('')
const nextConnectCmd = ref('')

const nextSavingCmd = ref(false)
const allSavingCmd = ref(false)
const ncdSavingCmd = ref(false)

const fleetIco = computed(() => {
  return isAloDbFleetCoverage(props.fleet)
    ? 'mdi-select-group'
    : isAloDbFleetFormation(props.fleet)
    ? 'mdi-vector-circle'
    : 'mdi-multicast'
})

const nextSurfacingCmdInput = ref<InstanceType<typeof GliderCmdInput> | null>(null)
const allSurfacingCmdInput = ref<InstanceType<typeof GliderCmdInput> | null>(null)
const nextConnectCmdInput = ref<InstanceType<typeof GliderCmdInput> | null>(null)

const missions = computed(
  () => props.fleet.activeMissionIds?.map(id => store.myGetters?.missionsById[id])?.filter(m => !!m) ?? [],
)

const gliders = computed(() => missions.value.map(m => ({ id: m.misId, libelle: m.gliKey })))

const selectedGliderIdx = ref(0)

const showTabs = ref(true)

function cleanCommande(cmd: String) {
  let corrected = cmd.replace(/ /g, '')
  if (!corrected.endsWith(';')) corrected = `${corrected};`
  return corrected
}

const broadcastBindings: Record<
  BroadcastKind,
  {
    cmdModel: typeof nextSurfacingCmd
    savingFlag: typeof nextSavingCmd
    inputRef: typeof nextSurfacingCmdInput
  }
> = {
  next: { cmdModel: nextSurfacingCmd, savingFlag: nextSavingCmd, inputRef: nextSurfacingCmdInput },
  all: { cmdModel: allSurfacingCmd, savingFlag: allSavingCmd, inputRef: allSurfacingCmdInput },
  ncd: { cmdModel: nextConnectCmd, savingFlag: ncdSavingCmd, inputRef: nextConnectCmdInput },
}

async function addBroadcastCmd(kind: BroadcastKind) {
  const { cmdModel, savingFlag, inputRef } = broadcastBindings[kind]
  if (savingFlag.value) return
  const cmd = cmdModel.value
  if (cmd.length === 0) return
  if (!(await inputRef.value?.checkSaisie())) return
  savingFlag.value = true
  const cmdCleaned = cleanCommande(cmd)

  for (const mission of missions.value.filter(m => m.misActifOn)) {
    if (mission.gliId == null) continue
    try {
      await store.myActions.GLIDER_IRIS_NSD_REQUEST(mission.gliId)
      const modSettings = store.myGetters.modifiedNsdConfigs[mission.gliId].mod_settings
      const currentList =
        kind === 'next'
          ? [...modSettings.NextSurfacingDo_next.listAction]
          : kind === 'all'
          ? [...modSettings.NextSurfacingDo_all.listAction]
          : [...(modSettings.NextConnectDo?.listAction ?? [])]
      currentList.push(cmdCleaned)
      const priority = [...modSettings.NextSurfacingDo.priority_listAction]
      const newPriority = kind === 'ncd' && !priority.includes('ncd') ? [...priority, 'ncd'] : priority
      const priorityUpdate = newPriority.length !== priority.length ? { priority_listAction: newPriority } : undefined
      await store.myActions.GLIDER_UPDATE_MODIFIED_NSD({
        itemId: mission.gliId,
        newProperties: {
          mod_settings: {
            ...(priorityUpdate ? { NextSurfacingDo: priorityUpdate } : {}),
            ...(kind === 'next' ? { NextSurfacingDo_next: { listAction: currentList } } : {}),
            ...(kind === 'all' ? { NextSurfacingDo_all: { listAction: currentList } } : {}),
            ...(kind === 'ncd' ? { NextConnectDo: { listAction: currentList } } : {}),
          },
        },
      })
      await store.myActions.GLIDER_IRIS_NSD_SAVE_REQUEST(mission.gliId)
    } catch (e) {
      //console.error("Error adding NSD command to mission", mission.misId, e)
    }
  }

  nextTick(() => {
    cmdModel.value = ''
    savingFlag.value = false
  })
}

onMounted(() => {
  setTimeout(() => {
    showTabs.value = false
    nextTick(() => {
      showTabs.value = true
    })
  }, 100)
})

return { __sfc: true,props, nextSurfacingCmd, allSurfacingCmd, nextConnectCmd, nextSavingCmd, allSavingCmd, ncdSavingCmd, fleetIco, nextSurfacingCmdInput, allSurfacingCmdInput, nextConnectCmdInput, missions, gliders, selectedGliderIdx, showTabs, cleanCommande, broadcastBindings, addBroadcastCmd, store, MissionDetailNextSurfacingDo, GliderCmdInput }
}

})